import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M10 19V5.5a1 1 0 0 1 5 0V17a2 2 0 0 0 2 2h5l-3-3', key: '1w8g0z' }],
  ['path', { d: 'm22 19-3 3', key: '1ix4wq' }],
  ['path', { d: 'M5 19V5.5a1 1 0 0 1 5 0', key: '1d4oa3' }],
  ['path', { d: 'M5 5.5A2.5 2.5 0 0 0 2.5 3', key: 'gp646f' }],
];

/**
 * @component @name ZodiacScorpio
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTlWNS41YTEgMSAwIDAgMSA1IDBWMTdhMiAyIDAgMCAwIDIgMmg1bC0zLTMiIC8+CiAgPHBhdGggZD0ibTIyIDE5LTMgMyIgLz4KICA8cGF0aCBkPSJNNSAxOVY1LjVhMSAxIDAgMCAxIDUgMCIgLz4KICA8cGF0aCBkPSJNNSA1LjVBMi41IDIuNSAwIDAgMCAyLjUgMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/zodiac-scorpio
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const ZodiacScorpio = createLucideIcon('zodiac-scorpio', __iconNode);

export default ZodiacScorpio;
